import { render, staticRenderFns } from "./cardVirtualAssistantDelete.vue?vue&type=template&id=2eb9eb8c"
import script from "./cardVirtualAssistantDelete.vue?vue&type=script&lang=js"
export * from "./cardVirtualAssistantDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports